import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import ToggleButton from 'components/atoms/ToggleButton';
import { bindActionCreators, Dispatch } from 'redux';
import { SetPilotagePlanSettingAction, setPilotagePlanSettingAction } from 'store/actions/layoutActions';
import { PilotagePlanSettingType, RootState } from 'types';
import { VoidInterface } from 'types/functions';
import { checkDifferent } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface PilotagePlansSettingsModelProps {
    children?: string | JSX.Element | JSX.Element[];
    title?: string;
    language: string;
    id?: string;
    data: null | undefined;
    actions:
        | { onCancel: VoidInterface; onConfirm: (pilotagePlanSettings: PilotagePlanSettingType) => void }
        | undefined;
    setPilotagePlanSettingAction: SetPilotagePlanSettingAction;
    pilotagePlanSettings: PilotagePlanSettingType;
}

interface PilotagePlansSettingsModelState {
    language: string;
    errors: object;
    data: null;
    isLoading: boolean;
    pilotagePlanSettings: PilotagePlanSettingType;
}

class PilotagePlansSettingsModel extends Component<PilotagePlansSettingsModelProps, PilotagePlansSettingsModelState> {
    constructor(props: PilotagePlansSettingsModelProps) {
        super(props);
        this.state = {
            data: null,
            isLoading: false,
            errors: {},
            language: 'en',
            pilotagePlanSettings: {},
        };
    }

    static getDerivedStateFromProps(props: PilotagePlansSettingsModelProps, state: PilotagePlansSettingsModelState) {
        if (checkDifferent(props.pilotagePlanSettings, state.pilotagePlanSettings)) {
            return {
                pilotagePlanSettings: props.pilotagePlanSettings,
            };
        }
        return null;
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onConfirm(this.state.pilotagePlanSettings);
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    togglePilotagePlan = (key: string, value: boolean) => {
        this.props.setPilotagePlanSettingAction(key, { loading: true });
        setTimeout(() => {
            // code to add later
            this.props.setPilotagePlanSettingAction(key, { loading: false, value });
        }, 500);
    };

    render() {
        return (
            <Form onSubmit={this.handleFormSubmit} className="bg-white shadow w-smallModel  rounded ">
                <div className="p-4 no-select">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 ">
                        <div className="text-lg leading-6 font-bold">{translate('Pilotage plans settings')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                    <div>
                        {Object.keys(this.state.pilotagePlanSettings).map((key) => {
                            return (
                                <div key={key} className="flex items-center gap-1 py-1">
                                    {this.state.pilotagePlanSettings[key].loading ? (
                                        <Image
                                            alt="loading"
                                            className="w-4 mx-1"
                                            src="/static/images/loading.svg"
                                        ></Image>
                                    ) : (
                                        <ToggleButton
                                            onChange={() =>
                                                this.togglePilotagePlan(
                                                    key,
                                                    !this.state.pilotagePlanSettings[key].value
                                                )
                                            }
                                            value={this.state.pilotagePlanSettings[key].value}
                                        />
                                    )}
                                    <div>{translate(this.state.pilotagePlanSettings[key].label)}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="flex justify-end p-4 hidden">
                    <Button  className="px-4 py-1 font-bold border border-gray-200" onClick={this.handleFormCancel}>
                        {translate('No , Cancel')}
                    </Button>
                    <Button type="submit" className="px-4 py-2 bg-primary-submit rounded-md text-white">
                        {translate('Yes , Save')}
                    </Button>
                </div>
            </Form>
        );
    }
}

const pilotagePlansSettingsStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    pilotagePlanSettings: state.layout.pilotagePlanSettings,
});

const pilotagePlansSettingsDispatchToProps = (dispatch: Dispatch) => ({
    setPilotagePlanSettingAction: bindActionCreators(setPilotagePlanSettingAction, dispatch),
});

export default connect(
    pilotagePlansSettingsStateToProps,
    pilotagePlansSettingsDispatchToProps
)(PilotagePlansSettingsModel);
